// ---------------------------
// Global Properties rootStore
// This controls all of the high-level states of the application for view reactivity.

// eslint-disable-next-line
import {observable, action, computed, autorun} from 'mobx';
import imagePaths from '../../assets';

class GlobalPropsStore {

  constructor(rootStore) {
    this.rootStore = rootStore;
    this.imgs = imagePaths;
  }

  @observable currentProps = {
    currentTrim: this.defaultTrim,
    currentColor: '',
    currentInterior: '',
    currentView: 'exterior',
    activeCube : '',
    isLoading: false
  };

  @observable sliderSettings = {
    dots: true,
    infinite: true,
    speed: 100,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1800,
    lazyLoad: 'ondemand'
  };

  @observable availableTrims = {
    luxury : {
      "trimSlug": "luxury",
  		"trimTitle": "Luxury",
      "colorsAvailable" : ['SummitWhite', 'BlackRaven', 'CrystalWhiteTricoat', 'SatinSteelMetallic', 'EvergreenMetallic', 'ShadowMetallic', 'WaveMetallic', 'GarnetMetallic', 'DarkMoonMetallic', 'InfraredTintcoat']
    },
    premium_luxury : {
      "trimSlug": "premium_luxury",
      "trimTitle": "Premium Luxury",
      "colorsAvailable" : ['SummitWhite', 'BlackRaven', 'CrystalWhiteTricoat', 'SatinSteelMetallic', 'EvergreenMetallic', 'ShadowMetallic', 'WaveMetallic', 'GarnetMetallic', 'DarkMoonMetallic', 'InfraredTintcoat', 'DiamondSkyMetallic']
    },
    sport : {
      "trimSlug": "sport",
      "trimTitle": "Sport",
      "colorsAvailable" : ['SummitWhite', 'BlackRaven', 'CrystalWhiteTricoat', 'SatinSteelMetallic', 'EvergreenMetallic', 'ShadowMetallic', 'WaveMetallic', 'VelocityRed', 'InfraredTintcoat']
    },
    ct5_v : {
      "trimSlug": "ct5_v",
      "trimTitle": "V-Series",
      "colorsAvailable" : ['VelocityRed', 'SummitWhite', 'BlackRaven', 'SatinSteelMetallic', 'EvergreenMetallic', 'ShadowMetallic', 'WaveMetallic', 'InfraredTintcoat', 'RiftMetallic']
    }
  }

  @observable colors = {
    SummitWhite: {
      "colorTitle": "Summit White",
      "disclaimer" : false,
      "colorSlug": "SummitWhite",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GAZ'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GAZ'],
        "sport" : this.imgs['exterior_sport_GAZ'],
        "ct5_v": this.imgs['exterior_ct5_v_GAZ']
      }
    },
    BlackRaven : {
      "colorTitle": "Black Raven",
      "disclaimer" : false,
      "colorSlug": "BlackRaven",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GBA'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GBA'],
        "sport" : this.imgs['exterior_sport_GBA'],
        "ct5_v": this.imgs['exterior_ct5_v_GBA']
      }
    },
    CrystalWhiteTricoat : {
      "colorTitle": "Crystal White Tricoat",
      "disclaimer" : "Available at extra charge. Not available on V-Series.",
      "colorSlug": "CrystalWhiteTricoat",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_G1W'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_G1W'],
        "sport" : this.imgs['exterior_sport_G1W']
      }
    },
    SatinSteelMetallic : {
      "colorTitle": "Satin Steel Metallic",
      "disclaimer" : "Available at extra charge.",
      "colorSlug": "SatinSteelMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_G9K'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_G9K'],
        "sport" : this.imgs['exterior_sport_G9K'],
        "ct5_v": this.imgs['exterior_ct5_v_G9K']
      }
    },
    EvergreenMetallic: {
      "colorTitle": "Evergreen Metallic",
      "disclaimer" : 'Available at extra charge. Limited availability.',
      "colorSlug": "EvergreenMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GJ0'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GJ0'],
        "sport" : this.imgs['exterior_sport_GJ0'],
        "ct5_v": this.imgs['exterior_ct5_v_GJ0']
      }
    },
    ShadowMetallic: {
      "colorTitle": "Shadow Metallic",
      "disclaimer" : 'Available at extra charge.',
      "colorSlug": "ShadowMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GJI'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GJI'],
        "sport" : this.imgs['exterior_sport_GJI'],
        "ct5_v": this.imgs['exterior_ct5_v_GJI']
      }
    },
    WaveMetallic: {
      "colorTitle": "Wave Metallic",
      "disclaimer" : 'Available at extra charge.',
      "colorSlug": "WaveMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GKK'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GKK'],
        "sport" : this.imgs['exterior_sport_GKK'],
        "ct5_v": this.imgs['exterior_ct5_v_GKK']
      }
    },
    GarnetMetallic: {
      "colorTitle": "Garnet Metallic",
      "disclaimer" : 'Available at extra charge. Only available on Luxury and Premium Luxury.',
      "colorSlug": "GarnetMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GLR'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GLR'],
      }
    },
    DarkMoonMetallic: {
      "colorTitle": "Dark Moon Metallic",
      "disclaimer" : 'Available at extra charge. Only available on Luxury and Premium Luxury. Limited availability',
      "colorSlug": "DarkMoonMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GLU'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GLU'],
      }
    },
    InfraredTintcoat: {
      "colorTitle": "Infrared Tintcoat",
      "disclaimer" : "Available at extra charge.",
      "colorSlug": "InfraredTintcoat",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "luxury" : ['h2g', 'hit'],
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun'],
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "luxury" : this.imgs['exterior_luxury_GSK'],
        "premium_luxury" : this.imgs['exterior_premium_luxury_GSK'],
        "sport" : this.imgs['exterior_sport_GSK'],
        "ct5_v": this.imgs['exterior_ct5_v_GSK']
      }
    },
    DiamondSkyMetallic: {
      "colorTitle": "Diamond Sky Metallic",
      "disclaimer" : "Late availability starting in early 2021. Included and only available with Diamond Sky Special Edition Package. Only available on Premium Luxury.",
      "colorSlug": "DiamondSkyMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "premium_luxury": ['h1y', 'hik', 'hav', 'hzk', 'hun']
      },
      "exteriorImages" : {
        "premium_luxury" : this.imgs['exterior_premium_luxury_G9F']
      }
    },
    VelocityRed: {
      "colorTitle": "Velocity Red",
      "disclaimer" : "Available at extra charge. Only available on Sport and V-Series.",
      "colorSlug": "VelocityRed",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "sport": ['hxr', 'h2x', 'hnd', 'hzk'],
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "sport" : this.imgs['exterior_sport_G7C'],
        "ct5_v": this.imgs['exterior_ct5_v_G7C']
      }
    },
    RiftMetallic: {
      "colorTitle": "Rift Metallic",
      "disclaimer" : "Available at extra charge. Only available on V-Series.",
      "colorSlug": "RiftMetallic",
      "colorHex": "#bb5530",
      "interiorsAvailable" : {
        "ct5_v": ['hxr', 'h2x', 'hnd', 'hzk']
      },
      "exteriorImages" : {
        "ct5_v": this.imgs['exterior_ct5_v_GRW']
      }
    }
  }

  @observable interiors = {
    h2g : {
      "interiorID": "h2g",
      "disclaimer" : false,
      "interiorTitle": "Jet Black with leatherette seats and low-gloss Axiom Aluminum trim",
      "interiorSlug": "jetBlackWithJetBlackAccentsLeatheretteSeatingSurfaces",
      "interiorImages" : {
        "luxury" : this.imgs['interior_luxury_H2G']
      },
      "interiorThumb" : this.imgs['thumbPL_luxury_H2G']
    },
    hit : {
      "interiorID": "hit",
      "disclaimer" : false,
      "interiorTitle": "Sahara Beige/Jet Black with leatherette seats and low-gloss Axiom Aluminum trim",
      "interiorSlug": "saharaBeigeWithJetBlackAccentsLeatheretteSeatingSurfaces",
      "interiorImages" : {
        "luxury" : this.imgs['interior_luxury_HIT']
      },
      "interiorThumb" : this.imgs['thumbPL_luxury_HIT']
    },
    h1y : {
      "interiorID": "h1y",
      "disclaimer" : false,
      "interiorTitle": "Jet Black with leather seating surfaces and Brushed Aluminum trim",
      "interiorSlug": "jetBlackWithJetBlackAccentsLeatherAppointedSeatingWithMiniPerforatedInserts",
      "interiorImages" : {
        "premium_luxury" : this.imgs['interior_premium_luxury_H1Y']
      },
      "interiorThumb" : this.imgs['thumbPL_premium_luxury_H1Y']
    },
    hik : {
      "interiorID": "hik",
      "disclaimer" : false,
      "interiorTitle": "Sahara Beige/Jet Black with leather seating surfaces and Misty Matrix wood trim",
      "interiorSlug": "saharaBeigeWithJetBlackAccentsLeatherappointedSeatingWithMiniperforatedInserts",
      "interiorImages" : {
        "premium_luxury" : this.imgs['interior_premium_luxury_HIK']
      },
      "interiorThumb" : this.imgs['thumbPL_premium_luxury_HIK']
    },
    hav : {
      "interiorID": "hav",
      "disclaimer" : false,
      "interiorTitle": "Maple Sugar/Jet Black with leather seating surfaces and Natural Finish Elm wood trim",
      "interiorSlug": "mapleSugarWithJetBlackAccentsLeatherappointedSeatingWithMiniperforatedInserts",
      "interiorImages" : {
        "premium_luxury" : this.imgs['interior_premium_luxury_HAV']
      },
      "interiorThumb" : this.imgs['thumbPL_premium_luxury_HAV']
    },
    hxr : {
      "interiorID": "hxr",
      "disclaimer" : false,
      "interiorTitle": "Jet Black with leatherette seats and Twenty-Two carbon-fiber trim",
      "interiorSlug": "jetBlackWithJetBlackAccentsLeatheretteSeatingSurfacesHxr",
      "interiorImages" : {
        "sport" : this.imgs['interior_sport_HXR'],
        "ct5_v" : this.imgs['interior_ct5_v_HXR']
      },
      "interiorThumb" : this.imgs['thumbPL_ct5_v_HXR']
    },
    h2x : {
      "interiorID": "h2x",
      "disclaimer"Available. Requires Climate Package."interiorTitle": "Jet Black with leather seating surfaces and Twenty-Two carbon-fiber trim",
      "interiorSlug": "jetBlackWithJetBlackAccentsLeatherappointedSeatingWithMiniperforatedInserts",
      "interiorImages" : {
        "sport" : this.imgs['interior_sport_H2X'],
        "ct5_v" : this.imgs['interior_ct5_v_H2X']
      },
      "interiorThumb" : this.imgs['thumbPL_sport_H2X']
    },
    hnd : {
      "interiorID": "hnd",
      "disclaimer"Available. Requires Climate Package."interiorTitle": "Whisper Beige/Jet Black with leather seating surfaces and Twenty-Two carbon-fiber trim",
      "interiorSlug": "whisperBeigeWithJetBlackAccentsLeatherappointedSeatingWithMiniperforatedInserts",
      "interiorImages" : {
        "sport" : this.imgs['interior_sport_HND'],
        "ct5_v" : this.imgs['interior_ct5_v_HND']
      },
      "interiorThumb" : this.imgs['thumbPL_sport_HND']
    },
    hzk : {
      "interiorID": "hzk",
      "disclaimer" : "Requires the available Platinum Package.",
      "interiorTitle": "Sedona Sauvage/Jet Black with Semi-Aniline full-leather seating and Twenty-Two carbon-fiber trim",
      "interiorSlug": "sedonaSauvageWithJetBlackAccentsSemianilineLeatherSeatsWithChevronPerforatedInserts",
      "interiorImages" : {
        "premium_luxury" : this.imgs['interior_premium_luxury_HZK'],
        "sport" : this.imgs['interior_sport_HZK'],
        "ct5_v" : this.imgs['interior_ct5_v_HZK']
      },
      "interiorThumb" : this.imgs['thumbPL_premium_luxury_HZK']
    },
    hun : {
      "interiorID": "hun",
      "disclaimer" : "Late availability starting early 2021. Requires available Diamond Sky Special Edition. Only available on Premium Luxury.",
      "interiorTitle": "Sky Cool Gray/Jet Black, leather seating surfaces, Diamond Fall seat perforations and Galaxy wood trim",
      "interiorSlug": "sedonaSauvageWithJetBlackAccentsSemianilineLeatherSeatsWithChevronPerforatedInserts",
      "interiorImages" : {
        "premium_luxury" : this.imgs['interior_premium_luxury_HUN']
      },
      "interiorThumb" : this.imgs['thumbPL_premium_luxury_HUN']
    }
  }

  @observable byoLinks = {

  }

  @computed get getAvailableTrims(){
    return this.availableTrims;
  }

  @computed get getAvailableInteriors(){
    return this.availabeInteriors;
  }

  @computed get getInteriors(){
    return this.interiors;
  }

  @computed get getByoLinks(){
    return this.byoLinks;
  }

  @computed get getColors(){
    return this.colors;
  }

  @computed get getCurrentProps(){
    return this.currentProps;
  }

  @computed get getSliderProps(){
    return this.sliderSettings;
  }

  @action setCurrentProps = (prop,value) => {
    this.currentProps[prop] = value;
  }

}

export default GlobalPropsStore;
